module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "30px",
      "margin-bottom": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [(this.event.isConfirmed) ? _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.unconfirmationShown = true
      }
    }
  }, [_vm._v("\n          Save & Unconfirm\n        ")]) : _vm._e(), _vm._v(" "), (!this.event.isConfirmed) ? _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.confirmationShown = true
      }
    }
  }, [_vm._v("\n          Save & Confirm\n        ")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('b-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "confirm_modal",
      "title": "Are your sure?",
      "ok-title": "Confirm and activate"
    },
    on: {
      "ok": _vm.saveAndConfirm
    },
    model: {
      value: (_vm.confirmationShown),
      callback: function($$v) {
        _vm.confirmationShown = $$v
      },
      expression: "confirmationShown"
    }
  }, [_vm._v("\n      This ​ ​will ​ ​activate ​ ​the ​ ​promotion, ​ ​are ​ ​you ​ ​sure to ​ ​activate ​ ​the ​ ​promotion?\n    ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "unconfirm_modal",
      "title": "Are your sure?",
      "ok-title": "Unconfirm and deactivate"
    },
    on: {
      "ok": _vm.saveAndUnconfirm
    },
    model: {
      value: (_vm.unconfirmationShown),
      callback: function($$v) {
        _vm.unconfirmationShown = $$v
      },
      expression: "unconfirmationShown"
    }
  }, [_vm._v("\n      This ​ ​will ​ ​deactivate ​ ​the ​ ​promotion, ​ ​are ​ ​you ​ ​sure to ​ ​deactivate ​ ​the ​ ​promotion?\n    ")]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": _vm.$v.$error
    }
  }, [_vm._v("\n      Please check that all fields are correct. Incorrect values are highlighted.\n    ")]), _vm._v(" "), _c('event-form', {
    attrs: {
      "regions": _vm.regions,
      "types": _vm.types,
      "$v": _vm.$v,
      "disableType": true,
      "disableRegion": true,
      "disableStartAndEndDate": true
    },
    model: {
      value: (_vm.event),
      callback: function($$v) {
        _vm.event = $$v
      },
      expression: "event"
    }
  }), _vm._v(" "), _c('event-items', {
    attrs: {
      "discounted-products": _vm.event.discountedProducts,
      "special-promotions": _vm.event.specialPromotions,
      "deleted-discounts-and-promotions": _vm.event.deletedDiscountsAndPromotions,
      "event-start-date": _vm.event.startDate,
      "event-end-date": _vm.event.endDate,
      "customer-groups": _vm.customerGroups,
      "region-id": _vm.event.regionId,
      "event-id": _vm.$route.params.id,
      "max-customer-group-id": _vm.maxCustomerGroupId,
      "is-event-confirmed": _vm.event.isConfirmed,
      "$v": _vm.$v.event
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "show": _vm.loading
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('h1', [_vm._v("\n          Special price event\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7e29a8cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/EditEvent/EditEvent.vue
// module id = 1699
// module chunks = 1